import {
  PAYOFF_CALLABILITY_BARRIER_LEVEL,
  PAYOFF_CALLABILITY_BARRIER_STEP_SIZE,
  PAYOFF_CALLABILITY_BARRIER_TYPE,
} from './product-capture-field-selectors.consts';

import { FCSelector } from '../../model/form-config.interface';

export const CALL_EVENT_BARRIER_TYPE: FCSelector = {
  formControlNames: [PAYOFF_CALLABILITY_BARRIER_TYPE],
  options: [
    {
      id: 'FLAT',
      label: 'Flat',
      effects: [
        {
          formControlNames: [
            PAYOFF_CALLABILITY_BARRIER_STEP_SIZE,
          ],
          hidden: true,
        },
        {
          formControlNames: [
            PAYOFF_CALLABILITY_BARRIER_LEVEL,
          ],
          hidden: false,
        }
      ],
    },
    {
      id: 'STEPPED',
      label: 'Stepped',
      effects: [
        {
          formControlNames: [
            PAYOFF_CALLABILITY_BARRIER_STEP_SIZE,
            PAYOFF_CALLABILITY_BARRIER_LEVEL
          ],
          hidden: false,
        },
      ],
    },
    {
      id: 'CUSTOM',
      label: 'Custom',
      effects: [{
        formControlNames: [
          PAYOFF_CALLABILITY_BARRIER_STEP_SIZE,
          PAYOFF_CALLABILITY_BARRIER_LEVEL
        ],
        hidden: true
      }]
    }
  ],
};
